export function hasLandingTab(): boolean {
	const element = document.querySelector(".hasLandingTab");
	return !!element;
}
